<template>
  <v-card class="elevation-12">
    <slot name="title"></slot>
    <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="shipmentsTotal"
        :options.sync="options"
        :loading="loading"
        :dense="settings.dense"
        :hide-default-footer="true"
        item-key="id"
    >
      <template v-slot:no-data>
        По Вашему запросу данных не найдено
      </template>

      <template v-slot:top="scope">
        <v-sheet
            color="grey lighten-3"
            class="px-4 pt-4 pb-3"
            tile
        >
          <h3 class="transition-swing font-weight-medium">Фильтрация</h3>

          <v-responsive>
            <v-row>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <DateInput v-model="filters.start"
                           label="Дата поставки начало"
                           @change="onStartChanged"
                           :disabled="startDisabled"
                           :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <DateInput v-model="filters.end"
                           label="Дата поставки конец"
                           @change="onEndChanged"
                           :disabled="endDisabled"
                           :dense="true"
                />
              </v-col>
              <v-col v-if="showBranchFilter" cols="12" sm="6" md="3" class="py-2">
                <v-autocomplete v-model="filters.branch"
                                :items="$store.getters.useBranches"
                                item-value="id"
                                :item-text="item => {return `${item.name} (${item.ownerName})`}"
                                :clearable="true"
                                label="Магазин"
                                :disabled="branchDisabled"
                                @change="onBranchChanged"
                                :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <v-autocomplete v-model="filters.isExecutorApproved"
                                :items="isExecutorApprovedOptions"
                                label="Подтверждён поставщиком"
                                @change="onIsExecutorApprovedChanged"
                                :disabled="isExecutorApprovedDisabled"
                                :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <v-autocomplete v-model="filters.isCustomerApproved"
                                :items="isCustomerApprovedOptions"
                                label="Подтверждён заказчиком"
                                @change="onIsCustomerApprovedChanged"
                                :disabled="isCustomerApprovedDisabled"
                                :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <v-autocomplete v-model="filters.isDeclined"
                                :items="isDeclinedOptions"
                                label="Отклонён заказчиком"
                                @change="onIsDeclinedChanged"
                                :disabled="isDeclinedDisabled"
                                :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <v-autocomplete v-model="filters.hasInvoice"
                                :items="hasInvoiceOptions"
                                label="ЭСФ создан"
                                @change="onHasInvoiceChanged"
                                :disabled="hasInvoiceDisabled"
                                :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <v-text-field v-model="filters.search"
                              label="Поиск"
                              append-icon="magnify"
                              single-line
                              hide-details
                              light
                              @input="onSearchInput"
                              :disabled="searchDisabled"
                              :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <v-autocomplete v-model="filters.status"
                                :items="statusOptions"
                                :clearable="true"
                                label="Статус"
                                :disabled="statusDisabled"
                                @change="onStatusChanged"
                                :dense="true"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="3" class="py-2">
                <v-autocomplete v-model="filters.statuses" :items="statusOptions" :clearable="true" label="Статусы" :disabled="false" @change="onStatusesChanged" :dense="true" multiple>
                 <template v-slot:selection="{item}">
                   <v-chip small="small" :class="elementClass(item)" close @click:close="removeSelectedStatus(item)">{{ item.text }}</v-chip>
                 </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-responsive>
        </v-sheet>
        <v-divider/>

        <v-card-actions>
          <template>
            <v-data-footer
                :pagination="scope.pagination"
                :options="scope.options"
                :items-per-page-options="itemsPerPageOptions"
                items-per-page-text="Показать по"
                @update:options="scope.updateOptions"
            />
          </template>

          <v-spacer/>

          <v-btn color="primary" icon @click="onSettingsIconClicked">
            <v-icon>fa-cog</v-icon>
          </v-btn>
          <v-btn color="primary" icon text @click="onReloadClicked">
            <v-icon>fa-sync</v-icon>
          </v-btn>
          <v-btn color="primary" icon @click="onAllExcelClicked">
            <v-icon>fa-file-excel</v-icon>
          </v-btn>
        </v-card-actions>
      </template>

      <template v-slot:body.append>
        <tr v-if="items.length">
          <td v-for="header in headers" :key="header.value">
            <h3 v-if="header.value === 'status'">Итого</h3>
            <h3 v-else-if="header.value === 'total'">{{ sumTotal | decimalMinorCeilTwoDigit }}</h3>
          </td>
        </tr>
      </template>

      <template v-slot:item.orderNumber="{item}">
        <template v-if="item.order">
          <OrderStatus :status="item.order.status" :id="item.order.id" :number="item.order.number" />
        </template>
      </template>
      <template v-slot:item.deliveryAddress="{item}">
        {{ item.deliveryAddress }}
      </template>
      <template v-slot:item.date="{item}">
        {{ item.date.format('DD.MM.YYYY') }}
      </template>
      <template v-slot:item.createdOn="{item}">
        {{ item.createdOn.format('DD.MM.YYYY HH:mm:ss') }}
      </template>
      <template v-slot:item.invoiceNumber="{item}">
        <template v-if="item.invoice">
          <InvoiceStatus :status="item.invoice.status" :number="item.invoice.number" :id="item.invoice.id" />
        </template>
      </template>
      <template v-slot:item.total="{item}">
        {{ item.total | decimalMinorCeilTwoDigit }}
      </template>
      <template v-slot:item.contrAgent="{item}">
        <template v-if="item.customerInn === $store.getters.companyInn">
          {{ item.consigneeName }}
        </template>
        <template v-else>
          {{ item.customerName }}
        </template>
      </template>
      <template v-slot:item.status="{item}">
        <ShipmentStatus :status="item.status" :id="item.id" :number="item.number"/>
      </template>
      <template v-slot:item.actions="{item}">
        <v-btn icon color="primary" x-small @click="onSingleExcelClicked(item)">
          <v-icon>fa-file-excel</v-icon>
        </v-btn>
        <v-btn icon color="primary" x-small class="ml-1" @click="onPrintClicked(item)">
          <v-icon>fa-print</v-icon>
        </v-btn>
        <v-btn icon color="primary" x-small class="ml-1" :to="{name: 'shipment-page', params: {id: item.id}}">
          <v-icon>fa-eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="settingsDialog" persistent max-width="720px">
      <v-card>
        <v-card-title>
          <span class="headline">Настройка таблицы</span>
        </v-card-title>

        <v-card-text>
          <h3 class="transition-swing font-weight-medium">Интерфейс</h3>
          <v-sheet color="grey lighten-3">
            <v-responsive>
              <v-autocomplete v-model="settings.dense"
                              :items="denseOptions"
                              :dense="true"
              />
            </v-responsive>
          </v-sheet>

          <h3 class="transition-swing font-weight-medium mt-2">Включить / выключить отображение колонок</h3>
          <v-sheet
              color="grey lighten-3"
              class="px-4 pt-4 pb-3"
              tile
          >
            <v-responsive>
              <v-switch v-for="column in settings.columns" v-model="column.display" :key="column.value"
                        color="primary"
                        :label="column.text"
                        dense
                        class="ma-0 pa-0"
                        :hide-details="true"
              />
            </v-responsive>
          </v-sheet>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="saveSettings(); settingsDialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import _ from 'underscore'
import DateInput from '@/components/Input/DateInput'
import ShipmentStatus from "@/components/Status/ShipmentStatus"
import * as ShipmentStatuses from "@/enum/ShipmentStatus"
import OrderStatus from "@/components/Status/OrderStatus"
import {GetStatusVariant} from "@/enum/ShipmentStatus";
import InvoiceStatus from "@/components/Status/InvoiceStatus";

export default {
  name: "ShipmentDataTable",
  components: {
    InvoiceStatus,
    ShipmentStatus,
    DateInput,
    OrderStatus
  },

  props: {
    shipments: {
      type: Array,
      default: () => {
        return []
      }
    },
    shipmentsTotal: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },


    // disables
    startDisabled: {
      type: Boolean,
      default: false
    },
    endDisabled: {
      type: Boolean,
      default: false
    },
    branchDisabled: {
      type: Boolean,
      default: false
    },
    isExecutorApprovedDisabled: {
      type: Boolean,
      default: false
    },
    isCustomerApprovedDisabled: {
      type: Boolean,
      default: false
    },
    isDeclinedDisabled: {
      type: Boolean,
      default: false
    },
    hasInvoiceDisabled: {
      type: Boolean,
      default: false
    },
    searchDisabled: {
      type: Boolean,
      default: false
    },
    statusDisabled: {
      type: Boolean,
      default: false
    },

    // hides
    showBranchFilter: {
      type: Boolean,
      default: true
    },


    // defaultValue
    startDefaultValue: {
      type: Object,
      default: null
    },
    endDefaultValue: {
      type: Object,
      default: null
    },
    branchDefaultValue: {
      type: Number,
      default: null
    },
    isExecutorApprovedDefaultValue: {
      type: Boolean,
      default: null
    },
    isCustomerApprovedDefaultValue: {
      type: Boolean,
      default: null
    },
    isDeclineDefaultValue: {
      type: Boolean,
      default: null
    },
    searchDefaultValue: {
      type: String,
      default: null
    },
    pageDefaultValue: {
      type: Number,
      default: null
    },
    limitDefaultValue: {
      type: Number,
      default: null
    },
    sortDefaultValue: {
      type: String,
      default: null
    },
    descDefaultValue: {
      type: Boolean,
      default: null
    },
    hasInvoiceDefaultValue: {
      type: Boolean,
      default: null
    },
    statusDefaultValue: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      settingsDialog: false,
      settings: {
        dense: true,
        columns: []
      },
      options: {
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false,

        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdOn'],
        sortDesc: [true],
      },
      filters: {
        start: null,
        end: null,
        branch: null,
        search: null,

        isCustomerApproved: null,
        isExecutorApproved: null,
        isDeclined: null,
        hasInvoice: null,
        status: null,
        statuses:[]
      },

      isExecutorApprovedOptions: [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ],
      isCustomerApprovedOptions: [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ],
      isDeclinedOptions: [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ],
      hasInvoiceOptions: [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ],
      denseOptions: [
        { text: 'Компактный', value: true},
        { text: 'Обычный', value: false}
      ],
      statusOptions: [
        {text:  ShipmentStatuses.GetStatusText(ShipmentStatuses.AwaitExecutorApprove), value: ShipmentStatuses.AwaitExecutorApprove},
        {text:  ShipmentStatuses.GetStatusText(ShipmentStatuses.ExecutorApproved), value: ShipmentStatuses.ExecutorApproved},
        {text:  ShipmentStatuses.GetStatusText(ShipmentStatuses.ExecutorDeleted), value: ShipmentStatuses.ExecutorDeleted},
        {text:  ShipmentStatuses.GetStatusText(ShipmentStatuses.ExecutorEdited), value: ShipmentStatuses.ExecutorEdited},
        {text:  ShipmentStatuses.GetStatusText(ShipmentStatuses.InvoiceCreated), value: ShipmentStatuses.InvoiceCreated},
        {text:  ShipmentStatuses.GetStatusText(ShipmentStatuses.CustomerApproved), value: ShipmentStatuses.CustomerApproved},
        {text:  ShipmentStatuses.GetStatusText(ShipmentStatuses.CustomerDeclined), value: ShipmentStatuses.CustomerDeclined},
        {text:  ShipmentStatuses.GetStatusText(ShipmentStatuses.CustomerEdited), value: ShipmentStatuses.CustomerEdited}
      ],

      columns: [
        {text: '№', value: 'displayNumber', sortable: false},
        {text: 'Номер поставки', value: 'status', sortable: false},
        {text: 'Дата поставки', value: 'date', sortable: true},
        {text: 'Сумма', value: 'total', sortable: true},
        {text: 'Пункт разгрузки', value: 'deliveryAddress', sortable: false},
        {text: 'Номер СФ', value: 'invoiceNumber', sortable: false},
        {text: 'Контрагент', value: 'contrAgent', sortable: true},
        {text: 'Создана', value: 'createdOn', sortable: true},
        {text: 'Заказ', value: 'orderNumber', sortable: true},
        {text: 'Действия', value: 'actions', sortable: false}
      ],

      itemsPerPageOptions: [10, 20, 50, 100, 200]
    }
  },

  computed: {
    headers() {
      let displayColumns = _.filter(this.settings.columns, column => {
        return column.display
      })

      return _.map(displayColumns, dc => {
        return _.find(this.columns, c => {
          return c.value === dc.value
        })
      })
    },
    sumTotal() {
      let sumTotal = 0
      _.each(this.shipments, i => {
        sumTotal += i.total
      })

      return sumTotal
    },
    items() {
      let number = 1;
      let skip = this.skip;

      return _.map(this.shipments, m => {
        m.displayNumber = skip + (number++)
        return m
      })
    },
    skip() {
      return (this.options.page - 1) * this.options.itemsPerPage
    },
  },

  methods: {
    elementClass(item){
      return GetStatusVariant(item.value)
    },
    removeSelectedStatus(item){
      const index = this.filters.statuses.indexOf(item.value)

      if(index !== null)
        this.filters.statuses.splice(index, 1)

      this.updateItems()
    },
    onBranchChanged() {
      this.updateItems()
    },
    onStartChanged() {
      this.updateItems()
    },
    onEndChanged() {
      this.updateItems()
    },
    onIsExecutorApprovedChanged() {
      this.updateItems()
    },
    onIsCustomerApprovedChanged() {
      this.updateItems()
    },
    onIsDeclinedChanged() {
      this.updateItems()
    },
    onHasInvoiceChanged() {
      this.updateItems()
    },
    onStatusChanged() {
      this.updateItems()
    },
    onStatusesChanged(){
      this.updateItems()
    },
    onReloadClicked() {
      this.updateItems()
    },
    onSettingsIconClicked() {
      this.settingsDialog = true
    },
    onPrintClicked(shipment) {
      this.$emit('print', shipment.id)
    },
    onSingleExcelClicked(shipment) {
      this.$emit('excel-single', shipment.id)
    },
    onAllExcelClicked() {
      this.$emit('excel-all', this.options, this.filters)
    },

    onSearchInput: _.debounce(function () {
      if (this.options.page === 1) {
        this.updateItems()
      } else {
        this.options.page = 1
      }
    }, 1000),

    updateItems() {
      this.$emit("update", this.options, this.filters)
    },

    saveSettings() {
      localStorage.shipmentsTableSettings = JSON.stringify(this.settings)
    },

    loadSettings() {
      let shipmentsTableSettingsStr = localStorage.shipmentsTableSettings
      if (typeof (shipmentsTableSettingsStr) === 'string') {
        let shipmentsTableSettings = JSON.parse(shipmentsTableSettingsStr)

        if (typeof (shipmentsTableSettings.dense) === 'boolean')
          this.settings.dense = shipmentsTableSettings.dense

        if (typeof (shipmentsTableSettings.columns) === 'object') {
          this.settings.columns = _.map(this.columns, column => {
            let shipmentsTableSettingsColumn = _.find(shipmentsTableSettings.columns, c => {
              return c.value === column.value
            }) || null

            return {
              value: column.value,
              text: column.text,
              display: shipmentsTableSettingsColumn ? shipmentsTableSettingsColumn.display : true
            }
          })
        }
      }
    },
  },

  watch: {
    options: {
      handler() {
        this.updateItems()
      }
    }
  },

  created() {
    // init default values
    if (typeof (this.isDeclineDefaultValue) === 'boolean')
      this.filters.isDeclined = this.isDeclineDefaultValue

    if (typeof (this.isCustomerApprovedDefaultValue) === 'boolean')
      this.filters.isCustomerApproved = this.isCustomerApprovedDefaultValue

    if (typeof (this.isExecutorApprovedDefaultValue) === 'boolean')
      this.filters.isExecutorApproved = this.isExecutorApprovedDefaultValue

    if (this.startDefaultValue)
      this.filters.start = this.startDefaultValue

    if (this.endDefaultValue)
      this.filters.end = this.endDefaultValue

    if (typeof(this.searchDefaultValue) === 'string')
      this.filters.search = this.searchDefaultValue

    if (typeof(this.branchDefaultValue) === 'number')
      this.filters.branch = this.branchDefaultValue

    if (typeof(this.statusDefaultValue) === 'number')
      this.filters.status = this.statusDefaultValue

    if (typeof(this.limitDefaultValue) === 'number')
      if (_.find(this.itemsPerPageOptions, option => { return option === this.limitDefaultValue }))
        this.options.itemsPerPage = this.limitDefaultValue

    if (typeof(this.pageDefaultValue) === 'number')
      this.options.page = this.pageDefaultValue

    if (typeof(this.descDefaultValue) === 'boolean')
      this.options.sortDesc = [this.descDefaultValue]

    if (typeof(this.sortDefaultValue) === 'string')
      if (_.find(this.columns, column => { return column.value === this.sortDefaultValue && column.sortable }))
        this.options.sortBy = [this.sortDefaultValue]


    this.settings.columns = _.map(this.columns, column => {
      return {
        value: column.value,
        text: column.text,
        display: true
      }
    })

    this.loadSettings()
  }
}
</script>

<style scoped>
.v-data-footer {
  justify-content: flex-start;
  -webkit-box-align: start;

  border-top: none !important;
}

.status {
  min-width: 110px;
  text-align: center;
  display: block;
}
</style>